import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';
import deepmerge from 'deepmerge';
import type { ReactElement, ReactNode } from 'react';
import { useEffect, useState } from 'react';

import { useSDK } from '../../app';
import { defaultTheme } from '../../theme/default';
import { Theme } from '../../theme/interface/detailed';

const ThemeProvider = ({ children }: { children: ReactNode }): ReactElement | null => {
	const rootStore = useSDK();
	const [theme, setTheme] = useState<Theme | null>(null);
	useEffect(() => {
		rootStore.api.resourcesApi.getDesign(rootStore.showcaseId).then(({ data }) => setTheme(data as Theme));
	}, [rootStore.api.resourcesApi, rootStore.showcaseId]);
	if (!theme) {
		return null;
	}
	return <EmotionThemeProvider theme={deepmerge(defaultTheme, theme)}>{children}</EmotionThemeProvider>;
};

export { ThemeProvider };
